export const isImageFile = (file?: string): file is string => {
  if (typeof file !== 'string') return false
  return (
    file.includes('.jpg') ||
    file.includes('.jpeg') ||
    file.includes('.png') ||
    file.includes('.webp') ||
    false
  )
}
